import * as u from './utils';

export default () => {
    const modal = document.querySelector('.marketing-popup');
    const close = modal.querySelector('.marketing-popup__close');
    const popup = modal.querySelector('.marketing-popup__popup');

    const closeModal = () => {
        u.removeClass(modal, 'is-active');
    };

    const stopClosure = (e) => {
        e.stopPropagation();
    };

    modal.addEventListener('click', closeModal);
    popup.addEventListener('click', stopClosure);
    close.addEventListener('click', closeModal);
};
